// ไฟล์: frontend/src/services/api.js
import axios from "axios";

// สร้าง instance ของ axios พร้อมกำหนดค่าเริ่มต้น
// const API = axios.create({
//   baseURL: "http://localhost:5000/api",
// });
const API_URL = 'https://cms2568.backend.kruwirat.com/api';

// console.log('Using API URL:', API_URL);
console.log('Using API URL:', 'OK');

// สร้าง instance ของ axios พร้อมกำหนดค่าเริ่มต้น
const API = axios.create({
  baseURL: API_URL,
  timeout: 15000, // เพิ่ม timeout เป็น 15 วินาที
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// เพิ่ม interceptor สำหรับเพิ่ม token ในทุกๆ คำขอ
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// บริการ API สำหรับการยืนยันตัวตน
export const authAPI = {
  login: (username, password) =>
    API.post("/auth/login", { username, password }),
};

// บริการ API สำหรับผู้ใช้
export const userAPI = {
  // ดึงข้อมูลผู้ใช้ทั้งหมด (เฉพาะ admin)
  getAllUsers: () => API.get("/users"),

  // ดึงข้อมูลครูทั้งหมด
  getAllTeachers: () => API.get("/teachers"),

  // ดึงข้อมูลผู้ใช้ตาม ID
  getUserById: (id) => API.get(`/users/${id}`),

  // ดึงข้อมูลผู้ใช้ปัจจุบัน
  getCurrentUser: () => API.get("/users/me/profile"),

  // เพิ่มผู้ใช้ใหม่ (ใช้ FormData สำหรับอัปโหลดรูปภาพ)
  createUser: (formData) => API.post("/users", formData),

  // อัปเดตข้อมูลผู้ใช้ (ใช้ FormData สำหรับอัปโหลดรูปภาพ)
  // updateUser: (id, formData) => API.put(`/users/${id}`, formData),
  updateUser: (id, formData) => API.put(`/users/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  

  // เปลี่ยนรหัสผ่าน
  changePassword: (id, data) => API.put(`/users/${id}/password`, data),

  // ลบผู้ใช้
  deleteUser: (id) => API.delete(`/users/${id}`),
};

// บริการ API สำหรับนักเรียน
export const studentAPI = {
  // ดึงข้อมูลนักเรียนทั้งหมด
  getAllStudents: () => API.get("/students"),

  // ดึงข้อมูลนักเรียนตาม ID
  getStudentById: (id) => API.get(`/students/${id}`),

  // ดึงข้อมูลนักเรียนในชั้นเรียน
  getStudentsByClass: (classId) => API.get(`/classes/${classId}/students`),

  // เพิ่มนักเรียนใหม่ (ใช้ FormData สำหรับอัปโหลดรูปภาพ)
  createStudent: (formData) => API.post("/students", formData),

  // อัปเดตข้อมูลนักเรียน (ใช้ FormData สำหรับอัปโหลดรูปภาพ)
  updateStudent: (id, formData) => API.put(`/students/${id}`, formData),

  // ลบนักเรียน
  deleteStudent: (id) => API.delete(`/students/${id}`),

  // เพิ่มนักเรียนเข้าชั้นเรียน
  addStudentToClass: (studentId, classId) =>
    API.post("/student-classes", { student_id: studentId, class_id: classId }),

  // ลบนักเรียนออกจากชั้นเรียน
  removeStudentFromClass: (studentId, classId) =>
    API.delete(`/student-classes/${studentId}/${classId}`),

  // เพิ่มฟังก์ชันสำหรับดึงประวัติน้ำหนักและส่วนสูง
  getStudentGrowthHistory: (id) => API.get(`/students/${id}/growth`),
};

// บริการ API สำหรับชั้นเรียน
export const classAPI = {
  // ดึงข้อมูลชั้นเรียนทั้งหมด
  getAllClasses: () => API.get("/classes"),

  // ดึงข้อมูลชั้นเรียนตาม ID
  getClassById: (id) => API.get(`/classes/${id}`),

  // ดึงข้อมูลชั้นเรียนของครู
  getClassesByTeacher: (teacherId) => API.get(`/teachers/${teacherId}/classes`),

  // ดึงข้อมูลชั้นเรียนของครูปัจจุบัน
  getMyClasses: () => API.get("/my-classes"),

  // เพิ่มชั้นเรียนใหม่
  createClass: (data) => API.post("/classes", data),

  // อัปเดตข้อมูลชั้นเรียน
  updateClass: (id, data) => API.put(`/classes/${id}`, data),

  // ลบชั้นเรียน
  deleteClass: (id) => API.delete(`/classes/${id}`),
};

// บริการ API สำหรับการเข้าเรียน
export const attendanceAPI = {
  // ดึงข้อมูลการเข้าเรียนตามชั้นเรียนและวันที่
  getAttendanceByClassAndDate: (classId, date) =>
    API.get(`/attendance/classes/${classId}/date/${date}`),

  // ดึงข้อมูลการเข้าเรียนของนักเรียนคนหนึ่ง
  getAttendanceByStudent: (studentId, startDate, endDate) => {
    let url = `/attendance/students/${studentId}`;
    if (startDate && endDate) {
      url += `?start_date=${startDate}&end_date=${endDate}`;
    }
    return API.get(url);
  },

  // ดึงสรุปการเข้าเรียนตามชั้นเรียน
  getAttendanceSummaryByClass: (classId, startDate, endDate) => {
    let url = `/attendance/summary/classes/${classId}`;
    if (startDate && endDate) {
      url += `?start_date=${startDate}&end_date=${endDate}`;
    }
    return API.get(url);
  },

  // บันทึกการเข้าเรียน
  recordAttendance: (data) => API.post("/attendance", data),

  // อัปเดตการเข้าเรียน
  updateAttendance: (id, data) => API.put(`/attendance/${id}`, data),

  // ลบข้อมูลการเข้าเรียน
  deleteAttendance: (id) => API.delete(`/attendance/${id}`),
};

// บริการ API สำหรับการออมเงิน
export const savingsAPI = {
  // ดึงข้อมูลการออมเงินตามชั้นเรียนและวันที่
  getSavingsByClassAndDate: (classId, date) =>
    API.get(`/savings/classes/${classId}/date/${date}`),

  // ดึงประวัติการออมเงินของนักเรียน
  getStudentSavingsHistory: (studentId) =>
    API.get(`/savings/students/${studentId}`),

  // ดึงสรุปยอดเงินออมตามชั้นเรียน
  getSavingsSummaryByClass: (classId) =>
    API.get(`/savings/summary/classes/${classId}`),

  // บันทึกรายการออมเงิน (ฝาก/ถอน)
  recordTransaction: (data) => API.post("/savings/transaction", data),

  // ลบรายการออมเงิน
  deleteTransaction: (id) => API.delete(`/savings/transaction/${id}`),
};

// เพิ่มบริการใหม่สำหรับการจัดการข้อมูลน้ำหนักและส่วนสูง
export const growthAPI = {
  // ดึงข้อมูลน้ำหนักและส่วนสูงตามนักเรียน
  getGrowthByStudent: (studentId) => API.get(`/growth/students/${studentId}`),

  // ดึงข้อมูลน้ำหนักและส่วนสูงตามชั้นเรียนและวันที่
  getGrowthByClassAndDate: (classId, date) =>
    API.get(`/growth/classes/${classId}/date/${date}`),

  // ดึงสรุปน้ำหนักและส่วนสูงตามชั้นเรียน
  getGrowthSummaryByClass: (classId) =>
    API.get(`/growth/summary/classes/${classId}`),

  // บันทึกน้ำหนักและส่วนสูง
  recordGrowth: (data) => API.post("/growth", data),

  // อัปเดตน้ำหนักและส่วนสูง
  updateGrowth: (id, data) => API.put(`/growth/${id}`, data),

  // ลบข้อมูลน้ำหนักและส่วนสูง
  deleteGrowth: (id) => API.delete(`/growth/${id}`),
};


// บริการ API สำหรับข้อมูลสุขภาพ (แปรงฟันและดื่มนม)
export const healthRecordAPI = {
  // ดึงข้อมูลการแปรงฟันและดื่มนมตามชั้นเรียนและวันที่
  getHealthRecordsByClassAndDate: (classId, date) => API.get(`/health-records/classes/${classId}/date/${date}`),
  
  // ดึงข้อมูลการแปรงฟันและดื่มนมของนักเรียนคนหนึ่ง
  getHealthRecordsByStudent: (studentId, startDate, endDate) => {
    let url = `/health-records/students/${studentId}`;
    if (startDate && endDate) {
      url += `?start_date=${startDate}&end_date=${endDate}`;
    }
    return API.get(url);
  },
  
  // ดึงสรุปข้อมูลการแปรงฟันและดื่มนมตามชั้นเรียน
  getHealthRecordSummaryByClass: (classId, startDate, endDate) => {
    let url = `/health-records/summary/classes/${classId}`;
    if (startDate && endDate) {
      url += `?start_date=${startDate}&end_date=${endDate}`;
    }
    return API.get(url);
  },
  
  // บันทึกข้อมูลการแปรงฟันและดื่มนม
  recordHealthRecord: (data) => API.post('/health-records', data),
  
  // อัปเดตข้อมูลการแปรงฟันและดื่มนม
  updateHealthRecord: (id, data) => API.put(`/health-records/${id}`, data),
  
  // ลบข้อมูลการแปรงฟันและดื่มนม
  deleteHealthRecord: (id) => API.delete(`/health-records/${id}`),
};


// บริการ API สำหรับผลงานครู
export const teacherWorkAPI = {
  // ดึงข้อมูลผลงานทั้งหมด (เฉพาะ admin)
  getAllTeacherWorks: () => API.get('/teacher-works'),
  
  // ดึงข้อมูลผลงานตาม ID
  getTeacherWorkById: (id) => API.get(`/teacher-works/${id}`),
  
  // ดึงข้อมูลผลงานของครูปัจจุบัน
  getMyTeacherWorks: () => API.get('/my-teacher-works'),
  
  // ดึงข้อมูลผลงานตามครู
  getTeacherWorksByTeacherId: (teacherId) => API.get(`/teachers/${teacherId}/works`),
  
  // เพิ่มผลงานใหม่ (ใช้ FormData สำหรับอัปโหลดไฟล์)
  createTeacherWork: (formData) => API.post('/teacher-works', formData),
  
  // อัปเดตข้อมูลผลงาน (ใช้ FormData สำหรับอัปโหลดไฟล์)
  updateTeacherWork: (id, formData) => API.put(`/teacher-works/${id}`, formData),
  
  // ลบผลงาน
  deleteTeacherWork: (id) => API.delete(`/teacher-works/${id}`),
  
  // URL สำหรับดาวน์โหลดไฟล์แนบ
  getDownloadUrl: (id) => `${API.defaults.baseURL}/teacher-works/${id}/download`
};


// บริการ API สำหรับแฟ้มผลงาน
export const portfolioAPI = {
  // ดึงข้อมูลแฟ้มผลงานทั้งหมด (เฉพาะ admin)
  getAllPortfolios: () => API.get('/portfolios'),
  
  // ดึงข้อมูลแฟ้มผลงานตาม ID
  getPortfolioById: (id) => API.get(`/portfolios/${id}`),
  
  // ดึงข้อมูลแฟ้มผลงานตามนักเรียน
  getPortfoliosByStudent: (studentId) => API.get(`/students/${studentId}/portfolios`),
  
  // ดึงข้อมูลแฟ้มผลงานตามชั้นเรียน
  getPortfoliosByClass: (classId) => API.get(`/classes/${classId}/portfolios`),
  
  // ดึงข้อมูลแฟ้มผลงานของครูที่เข้าสู่ระบบ
  getMyPortfolios: () => API.get('/my-portfolios'),
  
  // เพิ่มแฟ้มผลงานใหม่ (ใช้ FormData สำหรับอัปโหลดไฟล์)
  createPortfolio: (formData) => API.post('/portfolios', formData),
  
  // อัปเดตข้อมูลแฟ้มผลงาน (ใช้ FormData สำหรับอัปโหลดไฟล์)
  updatePortfolio: (id, formData) => API.put(`/portfolios/${id}`, formData),
  
  // ลบแฟ้มผลงาน
  deletePortfolio: (id) => API.delete(`/portfolios/${id}`),
  
  // ลบไฟล์แนบของแฟ้มผลงาน
  deletePortfolioFile: (fileId) => API.delete(`/portfolio-files/${fileId}`),
};

// บริการ API สำหรับหลักสูตรการอบรม
export const trainingCourseAPI = {
  // ดึงข้อมูลหลักสูตรทั้งหมด
  getAllCourses: () => API.get('/training-courses'),
  
  // ดึงข้อมูลหลักสูตรตาม ID
  getCourseById: (id) => API.get(`/training-courses/${id}`),
  
  // เพิ่มหลักสูตรใหม่
  createCourse: (data) => API.post('/training-courses', data),
  
  // อัปเดตข้อมูลหลักสูตร
  updateCourse: (id, data) => API.put(`/training-courses/${id}`, data),
  
  // ลบหลักสูตร
  deleteCourse: (id) => API.delete(`/training-courses/${id}`),
};

// บริการ API สำหรับการอบรมของครู
export const teacherTrainingAPI = {
  // ดึงข้อมูลการอบรมทั้งหมด (เฉพาะ admin)
  getAllTrainings: () => API.get('/teacher-trainings'),
  
  // ดึงข้อมูลการอบรมตาม ID
  getTrainingById: (id) => API.get(`/teacher-trainings/${id}`),
  
  // ดึงข้อมูลการอบรมของครู
  getTrainingsByTeacher: (teacherId) => API.get(`/teachers/${teacherId}/trainings`),
  
  // ดึงข้อมูลการอบรมของครูปัจจุบัน
  getMyTrainings: () => API.get('/my-trainings'),
  
  // ดึงสรุปการอบรมของครู
  getTrainingSummary: (teacherId, year) => {
    let url = `/teachers/${teacherId}/training-summary`;
    if (year) {
      url += `?year=${year}`;
    }
    return API.get(url);
  },
  
  // ดึงสรุปการอบรมของครูปัจจุบัน
  getMyTrainingSummary: (year) => {
    let url = '/my-training-summary';
    if (year) {
      url += `?year=${year}`;
    }
    return API.get(url);
  },
  
  // เพิ่มการอบรมใหม่ (ใช้ FormData สำหรับอัปโหลดไฟล์)
  createTraining: (formData) => API.post('/teacher-trainings', formData),
  
  // อัปเดตข้อมูลการอบรม (ใช้ FormData สำหรับอัปโหลดไฟล์)
  updateTraining: (id, formData) => API.put(`/teacher-trainings/${id}`, formData),
  
  // ลบข้อมูลการอบรม
  deleteTraining: (id) => API.delete(`/teacher-trainings/${id}`),
};


// บริการ API สำหรับวิชา
export const subjectAPI = {
  // ดึงข้อมูลวิชาทั้งหมด
  getAllSubjects: () => API.get('/subjects'),
  
  // ดึงข้อมูลวิชาตาม ID
  getSubjectById: (id) => API.get(`/subjects/${id}`),
  
  // เพิ่มวิชาใหม่
  createSubject: (data) => API.post('/subjects', data),
  
  // แก้ไขข้อมูลวิชา
  updateSubject: (id, data) => API.put(`/subjects/${id}`, data),
  
  // ลบวิชา
  deleteSubject: (id) => API.delete(`/subjects/${id}`),
};

// บริการ API สำหรับตัวชี้วัด
export const indicatorAPI = {
  // ดึงข้อมูลตัวชี้วัดทั้งหมด
  getAllIndicators: () => API.get('/indicators'),
  
  // ดึงข้อมูลตัวชี้วัดตาม ID
  getIndicatorById: (id) => API.get(`/indicators/${id}`),
  
  // ดึงข้อมูลตัวชี้วัดตามวิชา
  getIndicatorsBySubject: (subjectId) => API.get(`/subjects/${subjectId}/indicators`),
  
  // เพิ่มตัวชี้วัดใหม่
  createIndicator: (data) => API.post('/indicators', data),
  
  // แก้ไขข้อมูลตัวชี้วัด
  updateIndicator: (id, data) => API.put(`/indicators/${id}`, data),
  
  // ลบตัวชี้วัด
  deleteIndicator: (id) => API.delete(`/indicators/${id}`),
};

// บริการ API สำหรับคะแนน
export const scoreAPI = {
  // ดึงข้อมูลคะแนนของนักเรียนทั้งหมด
  getScoresByStudent: (studentId) => API.get(`/students/${studentId}/scores`),
  
  // ดึงข้อมูลคะแนนของนักเรียนตามวิชา
  getScoresByStudentAndSubject: (studentId, subjectId) => 
    API.get(`/students/${studentId}/subjects/${subjectId}/scores`),
  
  // ดึงข้อมูลคะแนนของนักเรียนทั้งชั้นตามตัวชี้วัด
  getScoresByClassAndIndicator: (classId, indicatorId) => 
    API.get(`/classes/${classId}/indicators/${indicatorId}/scores`),
  
  // บันทึกคะแนน
  recordScore: (data) => API.post('/scores', data),
  
  // แก้ไขคะแนน
  updateScore: (id, data) => API.put(`/scores/${id}`, data),
  
  // ลบคะแนน
  deleteScore: (id) => API.delete(`/scores/${id}`),
};



// อัปเดต export default โดยเพิ่ม savings เข้าไป
export default {
  auth: authAPI,
  user: userAPI,
  student: studentAPI,
  class: classAPI,
  attendance: attendanceAPI,
  savings: savingsAPI,
  growth: growthAPI,
  healthRecord: healthRecordAPI,
  teacherWork: teacherWorkAPI,
  portfolio: portfolioAPI,  // เพิ่มบรรทัดนี้
  trainingCourse: trainingCourseAPI,
  teacherTraining: teacherTrainingAPI,
  subject: subjectAPI,
  indicator: indicatorAPI,
  score: scoreAPI,
};
